import { render, staticRenderFns } from "./Lifestyle.vue?vue&type=template&id=26d118dc&scoped=true&"
import script from "./Lifestyle.vue?vue&type=script&lang=js&"
export * from "./Lifestyle.vue?vue&type=script&lang=js&"
import style0 from "./Lifestyle.vue?vue&type=style&index=0&id=26d118dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d118dc",
  null
  
)

export default component.exports